var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{ref:"captcha",staticClass:"captcha-container",attrs:{"sitekey":_vm.sitekey,"load-recaptcha-script":true},on:{"verify":_vm.onVerify,"expired":_vm.onExpire}})}
var staticRenderFns = []

export { render, staticRenderFns }